import * as React from "react";
import type { SVGProps } from "react";

interface SetWinProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const SetWin = ({ cancelled = false, ...props }: SetWinProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd" transform="translate(.35 .422)">
      <circle cx={11.65} cy={11.65} r={9.5} fill="#FFE42B" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M11.65 0C5.216 0 0 5.216 0 11.65S5.216 23.3 11.65 23.3 23.3 18.084 23.3 11.65 18.084 0 11.65 0m0 2.15a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="m2.695 7.276-.288.812a.515.515 0 0 0 .028.667l.182.155c.102.088.219.198.342.322.39.394.768.86 1.117 1.389.487.737.887 1.55 1.192 2.431l.222.69c1.335 4.099 3.717 6.924 6.74 7.847 1.044.32 1.888.222 3.069.06.282-.038.757-.11.718-.393l.597-.906c-.04-.28-.97-.094-1.25-.055-3.725.51-6.805-2.2-8.38-7.032l-.164-.518a12.4 12.4 0 0 0-1.43-2.979A10.7 10.7 0 0 0 4.078 8.14a8 8 0 0 0-.297-.286l-.232-.2-.09-.072c-.223-.177-.589-.53-.765-.305M8.532 2.15l.756-.237a.515.515 0 0 1 .722.163l.076.111.052.071q.105.142.244.307c.364.43.807.857 1.322 1.266q.96.764 2.142 1.346l.548.256c3.9 1.796 6.448 4.477 7.085 7.573.24 1.164.063 1.987-.268 3.244-.073.276-.21.84-.486.766l-.876.243c-.274-.074-.072-.735 0-1.009.972-3.697-1.347-7.135-5.947-9.305l-.524-.242a13.5 13.5 0 0 1-2.641-1.629 11 11 0 0 1-1.543-1.48 6 6 0 0 1-.514-.687c-.145-.238-.38-.605-.148-.757"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M11.65.85C5.685.85.85 5.685.85 11.65s4.835 10.8 10.8 10.8 10.8-4.835 10.8-10.8S17.615.85 11.65.85m0 1.3a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default SetWin;
